import { render, staticRenderFns } from "./template.html?vue&type=template&id=54ebf181&scoped=true&external"
import script from "./ExtremeMap.vue?vue&type=script&lang=js"
export * from "./ExtremeMap.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=54ebf181&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebf181",
  null
  
)

export default component.exports